import React, { useState, useEffect } from 'react';
import { Radio, FormControlLabel } from '@material-ui/core';
import { FormikProps, useField } from 'formik';
import axios from 'axios';
import get from 'lodash/get';
import { FormikTextField } from '../../../shared/Formik/FormikTextField';
import { FormikRadioGroup } from '../../../shared/Formik/FormikRadioGroup';
import { useAuth } from '../../../context/auth';
import leaderboard from '../../../assets/BannersPlaceholders/leaderboard.png';
import mediumRect from '../../../assets/BannersPlaceholders/mediumRect.png';
import poll from '../../../assets/BannersPlaceholders/poll.png';
import video from '../../../assets/BannersPlaceholders/video.png';
import { CampaignType, Label, StyledField, ErrorText } from '../../CreateCampign.styles';
import { StyledErrorText } from './BasicInformation.styles';

const campaignTypes = [
  {
    value: 'S',
    label: 'Medium Rectangle',
    image: mediumRect
  },
  {
    value: 'B',
    label: 'Leaderboard',
    image: leaderboard
  },
  {
    value: 'V',
    label: 'Video',
    image: video
  },
  {
    value: 'P',
    label: 'Poll',
    image: poll
  }
]

export const BasicInformation = (props: FormikProps<any>) => {
  const [campaignInformation, metaBasicInformation, basicInformationFieldHelper] = useField('basicInformation.adType');
  const [contentCampaign, metaContent, contentFieldHelper] = useField('content.campaignType')
  const [titleError, setTitleError] = useState(false);
  const title = props.values.basicInformation.title;
  const disabledTypeChange = sessionStorage.getItem('disabledTypeChange') === 'true' ? true : false;
  const oldTitle = sessionStorage.getItem('oldTitle');
  const { authToken } = useAuth();
  const handleCampaignTypeChange = (campaignType:string) => {
    if (!disabledTypeChange) {
      basicInformationFieldHelper.setValue(campaignType);
      contentFieldHelper.setValue(campaignType);
    }
  }
  const checkTitle = () => {
    axios.get(`${process.env.REACT_APP_BASE_URL}/api/campaign/campaign/check-title/?title=${encodeURIComponent(title)}`, {headers: { DTOKEN: `${authToken}`}}).then(res => {
      if (res.data.is_unique) {
        setTitleError(false)
        sessionStorage.setItem('uniqueTitle', 'true')
      }
      else {
        setTitleError(true)
        sessionStorage.setItem('uniqueTitle', 'false')
      }
    })
  }
  useEffect(() => {
    if (oldTitle !== title) {
      checkTitle();
    }
    else {
      setTitleError(false)
      sessionStorage.setItem('uniqueTitle', 'true')
    }
    if (!oldTitle) {
      checkTitle();
    }
  }, [title])

  return (
    <>
      <Label>Campaign Title</Label>
      <StyledField
        name="basicInformation.title"
        variant="outlined"
        fullWidth
        component={FormikTextField}
      />
      {titleError && <StyledErrorText>Campaign with this name already exists.</StyledErrorText>}
      <Label>Campaign description</Label>
      <StyledField
        name="basicInformation.description"
        variant="outlined"
        fullWidth
        multiline
        rows="3"
        component={FormikTextField}
      />
      <StyledField name="basicInformation.adType">
        {({ field, form, meta }: any) => (
          <>
          <FormikRadioGroup form={form} field={field} onChange={(e:any) => {
            handleCampaignTypeChange(e.target.value)
          }}>
            <Label>Campaign Type</Label>
            {campaignTypes.map(type => (
              <CampaignType active={type.value === props.values.basicInformation.adType} key={type.value} onClick={() => handleCampaignTypeChange(type.value)}>
                <FormControlLabel value={type.value} control={<Radio color="primary" disabled={disabledTypeChange} />} label={type.label} />
                <img src={type.image} alt={`${type.label} image`} />
              </CampaignType>
            ))}
          </FormikRadioGroup>
          {(get(form.errors, field.name) && form.submitCount > 0) && <ErrorText>{get(form.errors, field.name)}</ErrorText>}
          </>
        )}
      </StyledField>
    </>
  )
};
